// extracted by mini-css-extract-plugin
export default {"parent":"properties_parent__q7uXv","mainText":"properties_mainText__YYQJA","properties":"properties_properties__8+q2V"};